export default {"src":"/_next/static/media/skillz_dark_theme_icon.f71e8cfd.svg","height":15,"width":71,"blurWidth":0,"blurHeight":0};